import { buildResponsiveCSS } from '../../../utils/css.mjs';
import FlexContainer from '../../Containers/FlexContainer/FlexContainer.mjs';
import Heading from '../../Typography/Heading/Heading.mjs';
import TextComponent from '../../Typography/Text/Text.mjs';
import styled from 'styled-components';

const LEFT_BORDER_LINE_WIDTH = '6px';
const StyledRelatedStoriesFlexContainer = styled(FlexContainer) `
  position: relative;
  background: ${props => props.theme.colors.relatedStoriesBackground};
  padding: 1rem 1rem 1rem calc(1rem + ${LEFT_BORDER_LINE_WIDTH});
  ${props => buildResponsiveCSS('margin', props.margin)};

  &:before {
    display: block;
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: ${LEFT_BORDER_LINE_WIDTH};
    background-color: ${props => props.theme.colors.skyBlue};
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
    padding: 1rem 1.25rem 1rem calc(1.25rem + ${LEFT_BORDER_LINE_WIDTH});
  }
`;
const StyledRelatedStoriesHeading = styled(Heading) `
  margin: 0;
`;
const StyledRelatedStoriesText = styled(TextComponent) `
  margin: 0;
`;

export { StyledRelatedStoriesFlexContainer, StyledRelatedStoriesHeading, StyledRelatedStoriesText };
//# sourceMappingURL=RelatedStories.styles.mjs.map
